module.exports = __webpack_public_path__ + "static/media/22.9c129226.png";